import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = ({ children, onShowModal }) => {
    return (
        <div
            className="c-modal c-modal--left c-modal--detail-vehicle"
            aria-hidden={'false'}
            id="detail-vehicle-modal"
        >
            <div className="c-modal__overlay  js-modal-close" tabIndex="-1" />
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="Vehicle detail modal"
            >
                <header
                    className="c-modal__header"
                    style={{ position: 'unset', height: '10%' }}
                >
                    <button
                        onClick={onShowModal}
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Cerrar modal."
                    />
                </header>
                <div
                    className={`c-modal__content u-pt-none`}
                    role="document"
                    style={{ maxHeight: '90%' }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

Wrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    onShowModal: PropTypes.func.isRequired,
};

export default Wrapper;
